import { AxiosGlobalFilters } from '../config';
import qs from 'qs';
export const AutoReportService = {
  getConfiguredReports: ({ EmpresaId, UnidadeId, TipoRelatorioId }) => {
    return AxiosGlobalFilters({
      method: 'get',
      url: '/v1/relatoriosautomaticos',
      params: { TipoRelatorioId },
      headers: {
        'content-type': 'application/json',
        EmpresaId,
        UnidadeId,
      },
      paramsSerializer: params => {
        return qs.stringify(params, { arrayFormat: 'repeat' });
      },
    });
  },
  deleteConfiguratedReport: ({ id, EmpresaId, UnidadeId }) => {
    return AxiosGlobalFilters({
      method: 'delete',
      url: `/v1/relatoriosautomaticos/${id}`,
      headers: {
        'content-type': 'application/json',
        EmpresaId,
        UnidadeId,
      },
    });
  },
  activateConfiguredReport: ({ id, EmpresaId, UnidadeId }) => {
    return AxiosGlobalFilters({
      method: 'put',
      url: `/v1/relatoriosautomaticos/ativar/${id}`,
      headers: {
        'content-type': 'application/json',
        EmpresaId,
        UnidadeId,
      },
    });
  },
  deactivateConfiguredReport: ({ id, EmpresaId, UnidadeId }) => {
    return AxiosGlobalFilters({
      method: 'put',
      url: `/v1/relatoriosautomaticos/inativar/${id}`,
      headers: {
        'content-type': 'application/json',
        EmpresaId,
        UnidadeId,
      },
    });
  },
  getConfiguredReportById: ({ id, EmpresaId, UnidadeId }) => {
    return AxiosGlobalFilters({
      method: 'get',
      url: `/v1/relatoriosautomaticos/${id}`,
      headers: {
        'content-type': 'application/json',
        EmpresaId,
        UnidadeId,
      },
    });
  },
  saveReportConfiguration: ({ data, EmpresaId }) => {
    return AxiosGlobalFilters({
      method: 'post',
      url: '/v1/relatoriosautomaticos',
      data,
      headers: {
        'content-type': 'application/json',
        EmpresaId,
      },
    });
  },
  searchUsers: ({ query, EmpresaId, UnidadeId }) => {
    return AxiosGlobalFilters({
      method: 'get',
      url: '/v1/usuarios',
      params: { Search: query },
      headers: {
        'content-type': 'application/json',
        EmpresaId,
        UnidadeId,
      },
    });
  },
  saveReportEditConfiguration: ({ data, EmpresaId }) => {
    return AxiosGlobalFilters({
      method: 'put',
      url: '/v1/relatoriosautomaticos',
      data,
      headers: {
        'content-type': 'application/json',
        EmpresaId,
      },
    });
  },
};
